module.exports = __webpack_public_path__ + "img/card24.80eaa388.png";